/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Processing_StatusInputs */



/**
* | output |
* | --- |
* | "Processing subtitle file..." |
*
* @param {Iframe_Remote_Subtitle_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_processing_status = /** @type {((inputs?: Iframe_Remote_Subtitle_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement du fichier de sous-titres...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei wird verarbeitet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione del file dei sottotitoli...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка файла субтитров...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando archivo de subtítulos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理字幕文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルを処理しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक फ़ाइल संसाधित हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processando arquivo de legenda...")
	return /** @type {LocalizedString} */ ("Processing subtitle file...")
});